module.exports = __webpack_public_path__ + "img/11.699cb3e4.jpg";